import * as React from 'react';

import { FormControl, FormHelperText, InputBaseComponentProps, InputLabel, OutlinedInput } from '@mui/material';

export interface BaseInputSharedProps {
  onChange: (s: string) => void;
  onKeyPress?: (event: React.KeyboardEvent<HTMLDivElement>) => void;
  placeholder?: string;
  value: string;
  style?: React.CSSProperties;
  wrapperStyle?: React.CSSProperties;
  label?: string;
  className?: string;
  type?: 'text' | 'number';
  id: string;
  helperText?: string;
  error?: string;
  disabled?: boolean;
  dotFormat?: boolean;
  startAdornment?: React.ReactNode;
  endAdornment?: React.ReactNode;
  inputProps?: InputBaseComponentProps;
  maxWidth?: number | string;
}

type BaseInputProps =
  | (BaseInputSharedProps & {
      multiline: false;
    })
  | (BaseInputSharedProps & {
      multiline: true;
      rows: number;
      rowsMax: number;
    });

const BaseInput: React.FC<BaseInputProps> = ({
  id,
  onChange,
  placeholder,
  label,
  value,
  helperText,
  error,
  className,
  multiline,
  startAdornment,
  endAdornment,
  disabled,
  type = 'text',
  onKeyPress,
  inputProps,
  style,
  wrapperStyle,
  maxWidth = 500,
}) => {
  return (
    <FormControl error={!!error} fullWidth className={className} variant="outlined" style={{ maxWidth: maxWidth, ...wrapperStyle }}>
      {!!label && <InputLabel htmlFor={id}>{label}</InputLabel>}

      <OutlinedInput
        disabled={disabled}
        fullWidth
        style={style}
        type={type}
        value={value}
        onKeyPress={onKeyPress}
        placeholder={placeholder}
        onChange={(e) => {
          onChange(e.target.value);
        }}
        inputProps={inputProps}
        startAdornment={startAdornment}
        endAdornment={endAdornment}
        multiline={multiline}
        id={id}
        label={label}
      />

      <FormHelperText>{error || helperText}</FormHelperText>
    </FormControl>
  );
};
export default BaseInput;
